import { render } from "./OverdueReport.vue?vue&type=template&id=65261c4c"
import script from "./OverdueReport.vue?vue&type=script&lang=js"
export * from "./OverdueReport.vue?vue&type=script&lang=js"

import "./OverdueReport.vue?vue&type=style&index=0&id=65261c4c&lang=css"
script.render = render

export default script